import { t } from "@/i18n-js/instance";

import { DefaultFullPreview } from "../../..";
import type { ComponentLineProps } from "../types";
import { shouldExpandFirstPayment } from "../variants/helpers";

export const TaxLine = ({ preview, options }: ComponentLineProps) => {
  if (!shouldExpandFirstPayment(preview) || preview.first_payment.tax === 0) {
    return null;
  }

  return (
    <DefaultFullPreview.PreviewEntry
      label={t("paywall_checkout.coupon.tax")}
      value={preview.first_payment.formatted_tax}
      dataTestId="checkout-form-preview-today-tax"
      {...options}
    />
  );
};
